import { render } from "./NewsLetter.vue?vue&type=template&id=62c6aa63"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__